import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from 'hooks/useAuth';

interface PrivateRouteProps {
  children: React.ReactElement;
  requireAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('postLoginRedirect', `${location.pathname}${location.search}`);
    }
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('login', '1');
    return <Navigate to={{ pathname: '/', search: `?${searchParams.toString()}` }} replace />;
  }

  if (requireAdmin && !user?.isAdmin) {
    return <Navigate to="/admin/listas" replace />;
  }

  return children;
};

export default PrivateRoute;
